import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Submit } from 'shared/components/Form';
import LanguageSwitch from 'shared/components/LanguageSwitch';
import CookieSettings from './CookieSettings';
import styles from './CookieConsent.module.scss';

const CookieConsent = ({ language, onChangeLanguage, onSubmit }) => {
  const { t } = useTranslation('common');
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(prev => !prev);

  useEffect(() => {
    setTimeout(() => {
      try {
        document.getElementById('cookie-all').focus();
      } catch {}
    });
  }, []);

  const handleConsentSubmit = data => onSubmit(data || { analytics: true, marketing: true });

  const handleConsentAll = () => handleConsentSubmit();

  const handleConsentMinimum = () => onSubmit({ analytics: false, marketing: false });

  if (expanded) {
    return (
      <CookieSettings
        onSubmit={handleConsentSubmit}
        onCloseSettings={toggleExpanded}
      />
    );
  }
  return (
    <div className={styles.wrapper}>
      <div className="row">
        <div className={`col-12 ${styles.title}`}>
          <h2>{t('cookies.title')}</h2>
          <LanguageSwitch language={language} onChange={onChangeLanguage} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <p>{t('cookies.description')}</p>
        </div>
      </div>
      <div className={styles.buttonsRow}>
        <Submit
          id="cookie-all"
          className={styles.acceptAll}
          onClick={handleConsentAll}
          title={t('cookies.agree')}
        />
        <div className={styles.buttonsLeft}>
          <Submit
            onClick={handleConsentMinimum}
            title={t('cookies.agreeMinimum')}
            className={styles.acceptMin}
          />
          <Button
            className={styles.settings}
            onClick={toggleExpanded}
            title={t('cookies.settings')}
          />
        </div>
      </div>
    </div>
  );
};

CookieConsent.propTypes = {
  onSubmit: PropTypes.func,
};

CookieConsent.defaultProps = {
  onSubmit() {},
};

export default CookieConsent;
